import {
  SecurityPipelineGithubPageProps,
  SecurityPipelineGithubOrgPage,
} from "~/pages/integrations/security-pipeline/security-pipeline-github/SecurityPipelineGithubOrgPage/SecurityPipelineGithubOrgPage";

const SecurityPipelineGithubEntryPage = ({
  scope,
}: SecurityPipelineGithubPageProps) => {
  return <SecurityPipelineGithubOrgPage {...{ scope }} />;
};

export default SecurityPipelineGithubEntryPage;
